import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Colors, helperBgBlured, helperLinkReset, media } from '@utex/ui-kit';

import { ViewType } from './types';
interface ViewProps {
  view: ViewType;
}

interface ScrollProps {
  isScrolled?: boolean;
}

export function getColor(view: ViewType, isLogo?: boolean) {
  switch (view) {
    case 'white':
      return Colors.text.inverse;

    case 'black':
      return Colors.text.default;

    case 'default':
      return isLogo ? Colors.ut.alert : Colors.text.default;
  }
}

export const Container = styled('div')<ViewProps & ScrollProps>`
  backface-visibility: hidden;
  color: ${(props) => getColor(props.view)};
  transition: background-color 0.3s;
  ${(props) => props.view === 'default' && helperBgBlured};

  @media ${media.tablesktop} {
    position: fixed;
    z-index: 20;
    right: 0;
    left: 0;
    top: ${(props) => props.isScrolled && 0};
    color: ${(props) => props.isScrolled && Colors.text.default};
    ${(props) => props.isScrolled && helperBgBlured};
  }

  @media ${media.phonablet} {
    padding-right: 0 !important;
  }
`;

export const Wrapper = styled('div')`
  padding: 0 4rem;

  @media ${media.phonablet} {
    padding: 0 1.6rem;
  }
`;

export const UserBlockContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media ${media.tablesktop} {
    min-width: 30rem;
  }
`;

export const HeaderBlock = styled('header')<ScrollProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 120rem;
  padding: 2.3rem 0 2.1rem;
  transition: padding 0.3s;

  @media ${media.tablesktop} {
    padding-top: ${(props) => props.isScrolled && '1rem'};
    padding-bottom: ${(props) => props.isScrolled && '1.2rem'};
    box-shadow: ${(props) => props.isScrolled && `0 1px 0 0 ${Colors.ut.border10}`};
  }

  @media ${media.phonablet} {
    padding: 0.9rem 0;
  }
`;

export const Logo = styled('a')<ScrollProps>`
  ${helperLinkReset};
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  @media ${media.tablesktop} {
    height: ${(props) => props.isScrolled && '3.8rem'};
  }
`;

export const logoIcon = (view: ViewType, isScrolled?: boolean) => css`
  margin-right: 1.3rem;
  transform: ${isScrolled && 'scale(0.7)'};
  fill: ${getColor(view, true)};
  transition: transform 0.3s, fill 0.3s;

  @media ${media.tablesktop} {
    fill: ${isScrolled && Colors.ut.alert};
  }

  @media ${media.phonablet} {
    transform: scale(0.7);
  }
`;

export const logoText = (view: ViewType, isScrolled?: boolean) => css`
  fill: ${getColor(view)};
  transition: fill 0.3s;

  @media ${media.tablesktop} {
    fill: ${isScrolled && Colors.text.default};
  }

  @media ${media.phonablet} {
    height: 3.6rem;
  }
`;
